import { useCallback, useRef } from 'react'

export default function useSmartRef(initialValue) {
  // Nice trick for educational purposes and future reference but for hiding .current it's overkill and not perfectly hides internals of the Proxy 
  // -----------
  // const proxy = new Proxy(useRef(initialValue), {
  //   get(target, prop) {
  //     return target.current;
  //   },
  //   set(target, prop, value) {
  //     target.current = value;
  //     return true; // Must return true to indicate success
  //   }    
  // });
  const ref = useRef(initialValue);

  const get = useCallback(() => ref.current, []);
  const set = useCallback((value) => ref.current = value, []);  
  
  return {
    get, set
  }
}
